import './tabs';
import './submenu';
import './accordion';
import './people';
import './menu';
import './insurance';
import './tabs';
import Plyr from 'plyr';

import Swiper from 'swiper';
import browserUpdate from 'browser-update';

var mySwiper = new Swiper('.image-swiper', {
	// Optional parameters
	direction: 'horizontal',

	// If we need pagination
	pagination: {
		el: '.swiper-pagination',
	},

	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
});

var mySwiper = new Swiper('.news-swiper', {
	// Optional parameters
	direction: 'horizontal',
	loop: false,
	spaceBetween: 32,
	breakpoints: {
		0: {
			slidesPerView: 1,
			allowTouchMove: true,
		},
		768: {
			slidesPerView: 2,
			allowTouchMove: true,
		},
		1024: {
			slidesPerView: 3,
			allowTouchMove: false,
		},
	},
	// If we need pagination
	pagination: {
		el: '.swiper-pagination',
	},
});

const players = Plyr.setup('.js-player', {});

browserUpdate();
